export const numberOfItemsToLoad = (current: number, total: number) =>
  current + 3 > total ? current + (total - current) : current + 3;
